import React from 'react'
import ReactDOM from 'react-dom'
// import OutsideClickHandler from './Dropdown/OutSideClickHandler'
import Overlay from './Dropdown/Overlay'

const Modal = ({
  className,
  children,
  isShowing,
  toggle,
  overlayStyle,
  overlayClassName,
  ...otherProps
}) => isShowing &&
  ReactDOM.createPortal(
    <Overlay style={overlayStyle} className={overlayClassName}>
      {children}
    </Overlay>,
    document.body
  )

export default Modal
